// ----------------------------------------------------------------------

export const fullName = [
  'JI-701-0385',
  'JI-701-0475',
  'JI-701-0171',
  'JI-701-0473',
  'JI-701-0472',
  'JI-701-0477',
  'JI-701-0470',
  'JI-701-0474',
  'JI-701-0476',
  'JI-701-0479',
  'JI-701-0478',
  'JI-701-0415',
  'JI-701-0411',
  'JI-701-0412',
  'JI-701-0413',
  'JI-701-0414',
  'JI-701-0415',
  'JI-701-0416',
  'JI-701-0417',
  'JI-701-0418',
  'JI-701-0419',
  'JI-701-0420',
  'JI-701-0421',
  'JI-701-0422',
  'JI-701-0423',
  'JI-701-0424',
  'JI-701-0425',
  'JI-701-0426',
  'JI-701-0427',
  'JI-701-0428',
  'JI-701-0429',
  'JI-701-0430',
  'JI-701-0431',
  'JI-701-0432',
  'JI-701-0433',
  'JI-701-0434',
  'JI-701-0435',
  'JI-701-0436',
  'JI-701-0437',
  'JI-701-0438'
];

export const tglLelang = [
  '10-12-2021',
  '10-12-2021',
  '10-12-2021',
  '10-12-2021',
  '10-12-2021',
  '10-12-2021',
  '10-12-2021',
  '10-12-2021',
  '10-12-2021',
  '10-12-2021',
  '10-12-2021',
  '10-12-2021',
  '10-12-2021',
  '10-12-2021',
  '10-12-2021',
  '10-12-2021',
  '10-12-2021',
  '10-12-2021',
  '10-12-2021',
  '10-12-2021',
  '10-12-2021',
  '10-12-2021',
  '10-12-2021',
  '10-12-2021',
  '10-12-2021',
  '10-12-2021',
  '10-12-2021',
  '10-12-2021',
  '10-12-2021',
  '10-12-2021',
  '10-12-2021',
  '10-12-2021',
  '10-12-2021',
  '10-12-2021',
  '10-12-2021',
  '10-12-2021',
  '10-12-2021',
  '10-12-2021',
  '10-12-2021',
  '10-12-2021'
];

export const location = [
  'Depok, Jawa Barat',
  'Cileungsi, Jawa Barat',
  'Depok, Jawa Barat',
  'Menteng, Jakarta Pusat',
  'Menteng, Jakarta Pusat',
  'Menteng, Jakarta Pusat',
  'Menteng, Jakarta Pusat',
  'Menteng, Jakarta Pusat',
  'Depok, Jawa Barat',
  'Depok, Jawa Barat',
  'Depok, Jawa Barat',
  'Depok, Jawa Barat',
  'Depok, Jawa Barat',
  'Depok, Jawa Barat',
  'Depok, Jawa Barat',
  'Palmerah, Jakarta Barat',
  'Palmerah, Jakarta Barat',
  'Palmerah, Jakarta Barat',
  'Slipi, Jakarta Barat',
  'Bandung, Jawa Barat',
  'Bandung, Jawa Barat',
  'Bandung, Jawa Barat',
  'Bandung, Jawa Barat',
  'Bandung, Jawa Barat',
  'Tanjung Priok, Jakarta Utara',
  'Tanjung Priok, Jakarta Utara',
  'Tanjung Priok, Jakarta Utara',
  'Tanjung Priok, Jakarta Utara',
  'Tanjung Priok, Jakarta Utara',
  'Tanjung Priok, Jakarta Utara',
  'Tanjung Priok, Jakarta Utara',
  'Tanjung Priok, Jakarta Utara',
  'Tanjung Priok, Jakarta Utara',
  'Tanjung Priok, Jakarta Utara',
  'Tanjung Priok, Jakarta Utara',
  'Tanjung Priok, Jakarta Utara',
  'Tanjung Priok, Jakarta Utara',
  'Tanjung Priok, Jakarta Utara',
  'Tanjung Priok, Jakarta Utara',
  'Tanjung Priok, Jakarta Utara'
];

export const tipe = [
  'Rumah Tinggal',
  'Rumah Tinggal',
  'Rumah Tinggal',
  'Rumah Tinggal',
  'Rumah Tinggal',
  'Kendaraan',
  'Kendaraan',
  'Kendaraan',
  'Kendaraan',
  'Rumah Tinggal',
  'Rumah Tinggal',
  'Rumah Tinggal',
  'Rumah Tinggal',
  'Rumah Tinggal',
  'Rumah Tinggal',
  'Rumah Tinggal',
  'Rumah Tinggal',
  'Rumah Tinggal',
  'Rumah Tinggal',
  'Rumah Tinggal',
  'Rumah Tinggal',
  'Rumah Tinggal',
  'Rumah Tinggal',
  'Ruko',
  'Ruko',
  'Ruko',
  'Ruko',
  'Ruko',
  'Ruko',
  'Ruko',
  'Ruko',
  'Ruko',
  'Apartement',
  'Apartement',
  'Apartement',
  'Apartement',
  'Apartement',
  'Apartement',
  'Apartement',
  'Apartement'
];

export const PRODUCT_DETAIL2 = [
  '1.993.200.000',
  '1.593.200.000',
  '1.093.200.000',
  '1.193.200.000',
  '1.193.100.000',
  '1.193.100.000',
  '1.193.100.000',
  '1.193.200.000',
  '1.193.200.000',
  '1.193.200.000',
  '1.193.200.000',
  '1.193.200.000',
  '1.193.200.000',
  '1.193.200.000',
  '1.193.200.000',
  '1.193.200.000',
  '1.193.200.000',
  '1.193.200.000',
  '1.193.200.000',
  '1.193.200.000',
  '1.193.200.000',
  '1.193.200.000',
  '1.193.200.000',
  '1.193.200.000',
  '1.193.200.000'
];

export const PRODUCT_DETAIL = [
  '2.993.200.000',
  '2.593.200.000',
  '2.093.200.000',
  '2.193.200.000',
  '2.193.200.000',
  '2.193.200.000',
  '2.193.200.000',
  '2.193.200.000',
  '2.193.200.000',
  '2.193.200.000',
  '2.193.200.000',
  '2.193.200.000',
  '2.193.200.000',
  '2.193.200.000',
  '2.193.200.000',
  '2.193.200.000',
  '2.193.200.000',
  '2.193.200.000',
  '2.193.200.000',
  '2.193.200.000',
  '2.193.200.000',
  '2.193.200.000',
  '2.193.200.000',
  '2.193.200.000',
  '2.193.200.000'
];

export const tipe2 = [
  'Kendaraan',
  'Kendaraan',
  'Kendaraan',
  'Kendaraan',
  'Rumah Tinggal',
  'Rumah Tinggal',
  'Rumah Tinggal',
  'Kendaraan',
  'Kendaraan',
  'Kendaraan',
  'Kendaraan',
  'Kendaraan',
  'Kendaraan',
  'Kendaraan',
  'Kendaraan',
  'Kendaraan',
  'Kendaraan',
  'Kendaraan',
  'Kendaraan',
  'Kendaraan',
  'Kendaraan',
  'Kendaraan',
  'Kendaraan',
  'Kendaraan',
  'Kendaraan',
  'Kendaraan',
  'Kendaraan',
  'Kendaraan',
  'Kendaraan',
  'Kendaraan',
  'Kendaraan',
  'Kendaraan',
  'Apartement',
  'Apartement',
  'Apartement',
  'Apartement',
  'Apartement',
  'Apartement',
  'Apartement',
  'Apartement'
];

export const firstName = [
  'Mossie',
  'David',
  'Ebba',
  'Chester',
  'Eula',
  'Jaren',
  'Boyd',
  'Brady',
  'Aida',
  'Anastasia',
  'Gregoria',
  'Julianne',
  'Ila',
  'Elyssa',
  'Lucio',
  'Lewis',
  'Jacinthe',
  'Molly',
  'Brown',
  'Fritz',
  'Keon',
  'Ella',
  'Ken',
  'Whitney',
  'Monte',
  'Rose',
  'Shana',
  'Devon',
  'Jaleel',
  'Laury',
  'Brooks',
  'Bruce',
  'Avery',
  'Esperanza',
  'Helene',
  'Heloise',
  'Elinor',
  'Adeline',
  'Haley',
  'Anabelle'
];

export const lastName = [
  'Carroll',
  'Simonis',
  'Yost',
  'Hand',
  'Emmerich',
  'Wilderman',
  'Howell',
  'Sporer',
  'Boehm',
  'Morar',
  'Koch',
  'Reynolds',
  'Padberg',
  'Watsica',
  'Upton',
  'Yundt',
  'Pfeffer',
  'Parker',
  'Zulauf',
  'Treutel',
  'McDermott',
  'McDermott',
  'Cruickshank',
  'Parisian',
  'Auer',
  'Turner',
  'Dooley',
  'Wiegand',
  'Abbott',
  'Wisoky',
  'Fahey',
  'Satterfield',
  'Bahringer',
  'Schulist',
  'Durgan',
  'Carroll',
  'Jones',
  'Leffler',
  'Gutkowski',
  'Homenick'
];
